/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import TableHeading from '../../../components/common/Table/TableHeading/TableHeading'
import { PlusIcon } from '../../../images/icons/Plus/Plus'
import { ViewIcon } from '../../../images/icons/View/View'
import { AgentAdminIcon } from '../../../images/icons/AgentAdmin/AgentAdmin'
import Loading from '../../common/Loading/Loading'

/**
 *     Import
 *     - CSS
 */
import './styles/ManageAgency.css'
import { Button } from '../../common/Button/Button'

export default class ManageAgency extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            page: 1,
            perPage: 30,
            sorts: {
                sortedBy: 'fullName',
                sortedType: 'asc',
            },
        }
    }

    /**
     * After component mount, fetch the list of users
     */
    componentWillMount() {
        this.props.fetchUsers(this.state.page, this.state.perPage)
    }

    /**
     * Check if there's state change,
     * if yes, Trigger the fetch to return new results
     * seding the new state as param
     */

    // componentDidUpdate(prevProps: any, prevState: any) {

    //     if (prevState !== this.state && prevState.sorts !== this.state.sorts) {
    //         this.fetchUsersList()
    //     }
    // }

    fetchUsersList = (loadMore = false) => {
        const { page, perPage, sorts } = this.state
        const { sortedBy, sortedType } = sorts
        if (loadMore) {
            this.props.loadMoreUsersList(page, perPage, sortedBy, sortedType)
        } else {
            this.props.fetchUsers(page, perPage, sortedBy, sortedType)
        }
    }

    filterTrigger = (params) => {
        const { page, perPage } = this.state
        this.setState(
            {
                sorts: {
                    sortedBy: params.sortedBy,
                    sortedType: params.sortedType,
                },
            },
            () => { this.props.fetchUsers(1, (page * perPage), params.sortedBy, params.sortedType) })
    }

    /**
     * Manage 'Add New User' click
     */
    linkAddUser = () => this.props.history.push('manage-agency/add-user')

    render() {

        let users: any = []
        let usersCount = 0

        /**
         * List of headings
         * @type {Array}
         */
        let listHeadings = [
            { title: 'Agent Name', param: 'fullName' },
            { title: 'Gross written premium', param: '' },
            { title: 'Conversion rate', param: '' },
            { title: 'Active policies', param: '' },
            { title: 'Quotes', param: '' },
            { title: 'NTU', param: '' },
            { title: 'Lapses', param: '' },
        ]

        /**
         *
         * *** WIP ***
         *
         * Check if Fecth is done,
         * if Yes, set the list variables
         * if Not, return Loading
         */
        if (this.props.usersList.done) {
            users = this.props.usersList.users.users
            usersCount = this.props.usersList.users.usersCount
        } else {
            return (<Loading />)
        }
        const { page, perPage, sorts } = this.state
        const { sortedBy, sortedType } = sorts

        return (
            <div className="manageAgency">

                <HeaderContainer
                    className="manageAgency__header"
                    fullwidth={true}
                    titles={['Agency Management']}
                >
                    <div className="addNewUser" onClick={this.linkAddUser}><PlusIcon />Add new user</div>
                    <div className="usersCount">{`${usersCount} active ${(usersCount > 1) ? 'users' : 'user'}`}</div>
                </HeaderContainer>

                <Container
                    className={`manageAgency__headings table__headings ${this.state.sortedBy}`}
                    fullwidth={true}
                    shadow={true}
                >

                    {listHeadings.map((heading, i) => (
                        <TableHeading
                            key={i}
                            title={heading.title}
                            param={heading.param}
                            state={{
                                page,
                                perPage,
                                sortedBy,
                                sortedType,
                            }}
                            filterTrigger={this.filterTrigger}
                        />
                    ))}

                    <div className="table__title column cursor-hide">Actions</div>

                </Container>

                <Container className="manageAgency manageAgency__table table__content" fullwidth={false}>

                    {users.map((user: any, i: number) => (
                        <div className="table__row" key={i}>
                            <div className="column">{user.firstName} {user.surname}
                                {(user.agentAdmin) ? <AgentAdminIcon /> : null}</div>
                            <div className="column">£{user.grossWritten}</div>
                            <div className="column">{user.rate}</div>
                            <div className="column">{user.activePolicies}</div>
                            <div className="column">{user.quotes}</div>
                            <div className="column">{user.ntu}</div>
                            <div className="column">{user.lapses}</div>
                            <div className="column">
                                <Link to={`/agent-admin/manage-agency/user/${user.id}`}>
                                    <ViewIcon />
                                </Link>
                            </div>
                        </div>
                    )
                    )}

                </Container>
                {users.length !== usersCount && (
                    <div className="clients__footer">
                        <div className="clients__footer--brick quote_load_more">
                            <Button
                                disabled={users.length === usersCount}
                                type="submit"
                                // eslint-disable-next-line
                                onClick={() => {
                                    this.setState(
                                        prevState => ({
                                            page: prevState.page + 1,
                                        }),
                                        () => {
                                            const nextPage = this.state.page
                                            this.props.loadMoreUsersList(nextPage, perPage, sortedBy, sortedType)
                                        }
                                    )
                                }}
                            >
                                {this.props.loadMore ? <Loading /> : 'Load more'}
                            </Button>
                        </div>
                    </div>
                )}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/ManageAgency/ManageAgency.tsx